export default __webpack_public_path__ + "static/media/clinet18.b46de4a5.png";